
/* Variant color hover → image preview on product pages.
 *
 * Dawn's product gallery hides non-selected color images (display:none).
 * So we can't just scroll to them — we swap the hero image src/srcset
 * on hover, same technique as the collection card swatch hover.
 * On mouseout, restore to the currently selected color's image.
 */
(function() {
  if (window._fdVariantHover) return;
  window._fdVariantHover = 1;

  function init() {
    var vs = document.querySelector('variant-selects, variant-radios');
    if (!vs) return;

    var mg = document.querySelector('media-gallery');
    if (!mg) return;

    /* Parse variant JSON */
    var jsonEl = vs.querySelector('[type="application/json"]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);

    /* Find the color fieldset */
    var colorFieldset = null;
    var fieldsets = vs.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend) {
        var name = legend.textContent.trim().toLowerCase();
        if (name === 'color' || name === 'colour') {
          colorFieldset = fieldsets[i];
          break;
        }
      }
    }
    if (!colorFieldset) return;

    /* Determine option key (option1, option2, etc.) */
    var allFieldsets = Array.from(vs.querySelectorAll('fieldset'));
    var colorOptionIndex = allFieldsets.indexOf(colorFieldset);
    if (colorOptionIndex === -1) return;
    var optionKey = 'option' + (colorOptionIndex + 1);

    /* Build color → featured image URL map from variant data */
    var colorToImage = {};
    variants.forEach(function(v) {
      var color = v[optionKey];
      if (!colorToImage[color] && v.featured_image) {
        colorToImage[color] = v.featured_image.src;
      }
    });

    /* Find the hero image — first visible variant-specific media item's img */
    function getHeroImg() {
      var items = mg.querySelectorAll('.product__media-item--variant');
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetParent !== null) {
          return items[i].querySelector('img');
        }
      }
      /* Fallback: first img in the gallery */
      return mg.querySelector('.product__media-item img');
    }

    /* Generate srcset from a base URL */
    function buildSrcset(url) {
      var widths = [165, 360, 533, 720, 940, 1066];
      return widths.map(function(w) {
        return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
      }).join(', ');
    }

    /* Store original image state for restore */
    var origSrc = null;
    var origSrcset = null;
    var isHovering = false;

    function previewColor(color) {
      var url = colorToImage[color];
      if (!url) return;
      var img = getHeroImg();
      if (!img) return;

      /* Save original on first hover */
      if (!isHovering) {
        origSrc = img.src;
        origSrcset = img.srcset || '';
        isHovering = true;
      }

      img.src = url;
      img.srcset = buildSrcset(url);
    }

    function restoreImage() {
      if (!isHovering) return;
      var img = getHeroImg();
      if (img && origSrc) {
        img.src = origSrc;
        img.srcset = origSrcset;
      }
      isHovering = false;
      origSrc = null;
      origSrcset = null;
    }

    /* Listen for hover on color labels */
    var labels = colorFieldset.querySelectorAll('label');
    labels.forEach(function(label) {
      label.addEventListener('mouseenter', function() {
        var input = label.previousElementSibling;
        if (!input || input.type !== 'radio') {
          input = document.getElementById(label.getAttribute('for'));
        }
        if (!input) return;

        /* Skip if this color is already selected */
        if (input.checked) return;

        previewColor(input.value);
      });
    });

    /* Restore on mouseout from the entire color fieldset */
    colorFieldset.addEventListener('mouseleave', function() {
      restoreImage();
    });

    /* Reset saved state when a color is actually clicked (variant changes) */
    colorFieldset.addEventListener('change', function() {
      isHovering = false;
      origSrc = null;
      origSrcset = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
